import http from '../../utils/http';
import API_ENDPOINTS from '../../utils/api-endpoints';

const fetchGetAllEventDetails = async (input) => {
	const { data } = await http.post(`${API_ENDPOINTS.GET_ALL_OT_ANALYTICS_EVENTS}`, input);
	return data?.data;
};

export default fetchGetAllEventDetails;
